var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px","persistent":_vm.isIncomplete},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.charge)?_c('AppInvoice',{attrs:{"charge":_vm.charge}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }